import DefaultLayout from '##/Default';
import List from './List';

const routes = [
    {
        path: '/unit-types',
        exact: true,
        layout: DefaultLayout,
        component: List,
        auth: true,
        title: 'unit types'
    }

];

export default routes;
